// popup logic
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    const isDesktop = window.innerWidth > 1024;
    const lastClickDate = localStorage.getItem('lastClickDate');
    const today = new Date().toDateString(); // Текущая дата в строковом формате

    if (lastClickDate !== today) {
      const desktopLink = document.querySelector('.slide_link-chat_desktop');
      if (desktopLink) {
        desktopLink.click();
        localStorage.setItem('lastClickDate', today); // Обновляем дату в хранилище
      }
    }
  }, 2000);
});

document.addEventListener("DOMContentLoaded", function() {
//seacrh bar logic
const openSearchPopup = document.getElementById("open-search-bar");
const openSearchMobilePopup = document.querySelector(".open-search-bar_mobile");

const allHeaderArea = document.getElementById("shopify-section-header");
const mainSearchArea = document.getElementById("main-search"); 
const closeMainSearch = document.querySelectorAll(".main-search__close ");

const body = document.body;

function hideMainSearch() {
  mainSearchArea.style.visibility = "hidden";
  mainSearchArea.style.opacity = "0";
}

openSearchMobilePopup.addEventListener("click", () => {

  mainSearchArea.style.visibility = "visible";
  mainSearchArea.style.opacity = "1";
  body.classList.add("show-search");
})

openSearchPopup.addEventListener("click", () => {
  mainSearchArea.style.visibility = "visible";
  mainSearchArea.style.opacity = "1";
  body.classList.add("show-search");
})


closeMainSearch.forEach((button) => {
  button.addEventListener("click", () => {
    hideMainSearch()
})
}) 

document.addEventListener("click", (event) => {
  const isClickInsideMainSearch = allHeaderArea.contains(event.target);
  if (!isClickInsideMainSearch) {
    hideMainSearch();
  }
});
});


//1-1
const navTierWrapper1 = document.getElementById("NavigationTier-Wrapper-2-2");
const navigationTier3_1_1 = navTierWrapper1.querySelector("#NavigationTier3-1");

if (navigationTier3_1_1) {
  navigationTier3_1_1.addEventListener("mouseenter", function () {
    var megaMenuItem = navigationTier3_1_1.querySelector(".mega-menu__item_3");
    var megaMenuLink = navigationTier3_1_1.querySelector(
      ".navigation__column-title"
    );

    if (megaMenuItem) {
      megaMenuLink.style.fontWeight = "bold";
      megaMenuItem.style.display = "flex";
      megaMenuItem.style.zIndex = "9999";
      megaMenuItem.style.pointerEvents = "auto";
    }
  });

  navigationTier3_1_1.addEventListener("mouseleave", function () {
    var megaMenuItem = navigationTier3_1_1.querySelector(".mega-menu__item_3");
    var megaMenuLink = navigationTier3_1_1.querySelector(
      ".navigation__column-title"
    );

    if (megaMenuItem) {
      megaMenuLink.style.fontWeight = "400";
      megaMenuItem.style.display = "none";
      megaMenuItem.style.zIndex = "-1";
      megaMenuItem.style.pointerEvents = "none";
    }
  });
}

//1-2
const navigationTier3_2_1 = navTierWrapper1.querySelector("#NavigationTier3-2");
if (navigationTier3_2_1) {
  navigationTier3_2_1.addEventListener("mouseenter", function () {
    var megaMenuItem = navigationTier3_2_1.querySelector(".mega-menu__item_3");
    var megaMenuLink = navigationTier3_2_1.querySelector(
      ".navigation__column-title"
    );

    if (megaMenuItem) {
      megaMenuLink.style.fontWeight = "bold";
      megaMenuItem.style.display = "flex";
      megaMenuItem.style.zIndex = "9999";
      megaMenuItem.style.pointerEvents = "auto";
    }
  });

  navigationTier3_2_1.addEventListener("mouseleave", function () {
    var megaMenuItem = navigationTier3_2_1.querySelector(".mega-menu__item_3");
    var megaMenuLink = navigationTier3_2_1.querySelector(
      ".navigation__column-title"
    );

    if (megaMenuItem) {
      megaMenuLink.style.fontWeight = "400";
      megaMenuItem.style.display = "none";
      megaMenuItem.style.zIndex = "0";
      megaMenuItem.style.pointerEvents = "none";
    }
  });
}
  
// 1-3
const navigationTier3_3_1 = navTierWrapper1.querySelector("#NavigationTier3-3");
if (navigationTier3_3_1) {
  navigationTier3_3_1.addEventListener("mouseenter", function () {
    var megaMenuItem = navigationTier3_3_1.querySelector(".mega-menu__item_3");
    var megaMenuLink = navigationTier3_3_1.querySelector(
      ".navigation__column-title"
    );

    if (megaMenuItem) {
      megaMenuLink.style.fontWeight = "bold";
      megaMenuItem.style.display = "flex";
      // megaMenuItem.style.marginRight = "137px";
      megaMenuItem.style.zIndex = "9999";
      megaMenuItem.style.pointerEvents = "auto";
    }
  });

  navigationTier3_3_1.addEventListener("mouseleave", function () {
    var megaMenuItem = navigationTier3_3_1.querySelector(".mega-menu__item_3");
    var megaMenuLink = navigationTier3_3_1.querySelector(
      ".navigation__column-title"
    );

    if (megaMenuItem) {
      megaMenuLink.style.fontWeight = "400";
      megaMenuItem.style.display = "none";
      megaMenuItem.style.zIndex = "0";
      megaMenuItem.style.pointerEvents = "none";
    }
  });
}

//1-4
const navigationTier3_4_1 = navTierWrapper1.querySelector("#NavigationTier3-4");
if (navigationTier3_4_1) {
  navigationTier3_4_1.addEventListener("mouseenter", function () {
    var megaMenuItem = navigationTier3_4_1.querySelector(".mega-menu__item_3");
    var megaMenuLink = navigationTier3_4_1.querySelector(
      ".navigation__column-title"
    );

    if (megaMenuItem) {
      megaMenuLink.style.fontWeight = "bold";
      megaMenuItem.style.display = "flex";
      megaMenuItem.style.marginRight = "94px";
      megaMenuItem.style.zIndex = "9999";
      megaMenuItem.style.pointerEvents = "auto";
    }
  });

  navigationTier3_4_1.addEventListener("mouseleave", function () {
    var megaMenuItem = navigationTier3_4_1.querySelector(".mega-menu__item_3");
    var megaMenuLink = navigationTier3_4_1.querySelector(
      ".navigation__column-title"
    );

    if (megaMenuItem) {
      megaMenuLink.style.fontWeight = "400";
      megaMenuItem.style.display = "none";
      megaMenuItem.style.zIndex = "0";
      megaMenuItem.style.pointerEvents = "none";
    }
  });
}

//1-5
const navigationTier3_5_1 = navTierWrapper1.querySelector("#NavigationTier3-5");
if (navigationTier3_5_1) {
  navigationTier3_5_1.addEventListener("mouseenter", function () {
    var megaMenuItem = navigationTier3_5_1.querySelector(".mega-menu__item_3");
    var megaMenuLink = navigationTier3_5_1.querySelector(
      ".navigation__column-title"
    );

    if (megaMenuItem) {
      megaMenuLink.style.fontWeight = "bold";
      megaMenuItem.style.display = "flex";
      // megaMenuItem.style.marginRight = "97px";
      megaMenuItem.style.zIndex = "9999";
      megaMenuItem.style.pointerEvents = "auto";
    }
  });

  navigationTier3_5_1.addEventListener("mouseleave", function () {
    var megaMenuItem = navigationTier3_5_1.querySelector(".mega-menu__item_3");
    var megaMenuLink = navigationTier3_5_1.querySelector(
      ".navigation__column-title"
    );

    if (megaMenuItem) {
      megaMenuLink.style.fontWeight = "400";
      megaMenuItem.style.display = "none";
      megaMenuItem.style.zIndex = "-1";
      megaMenuItem.style.pointerEvents = "none";
    }
  });
}

//2-1
const navTierWrapper2 = document.getElementById("NavigationTier-Wrapper-2-4");
const navigationTier3_1 = navTierWrapper2.querySelector("#NavigationTier3-1");
if (navigationTier3_1) {
  navigationTier3_1.addEventListener("mouseenter", function () {
    var megaMenuItem = navigationTier3_1.querySelector(".mega-menu__item_3");
    var megaMenuLink = navigationTier3_1.querySelector(
      ".navigation__column-title"
    );

    if (megaMenuItem) {
      megaMenuLink.style.fontWeight = "bold";
      megaMenuItem.style.display = "flex";
      // megaMenuItem.style.marginRight = "97px";
      megaMenuItem.style.zIndex = "9999";
      megaMenuItem.style.pointerEvents = "auto";
    }
  });

  navigationTier3_1.addEventListener("mouseleave", function () {
    var megaMenuItem = navigationTier3_1.querySelector(".mega-menu__item_3");
    var megaMenuLink = navigationTier3_1.querySelector(
      ".navigation__column-title"
    );

    if (megaMenuItem) {
      megaMenuLink.style.fontWeight = "400";
      megaMenuItem.style.display = "none";
      megaMenuItem.style.zIndex = "-1";
      megaMenuItem.style.pointerEvents = "none";
    }
  });
}

//2-2
const navigationTier3_2 = navTierWrapper2.querySelector("#NavigationTier3-2");
if (navigationTier3_2) {
  navigationTier3_2.addEventListener("mouseenter", function () {
    var megaMenuItem = navigationTier3_2.querySelector(".mega-menu__item_3");
    var megaMenuLink = navigationTier3_2.querySelector(
      ".navigation__column-title"
    );

    if (megaMenuItem) {
      megaMenuLink.style.fontWeight = "bold";
      megaMenuItem.style.display = "flex";
      megaMenuItem.style.zIndex = "9999";
      megaMenuItem.style.pointerEvents = "auto";
    }
  });

  navigationTier3_2.addEventListener("mouseleave", function () {
    var megaMenuItem = navigationTier3_2.querySelector(".mega-menu__item_3");
    var megaMenuLink = navigationTier3_2.querySelector(
      ".navigation__column-title"
    );

    if (megaMenuItem) {
      megaMenuLink.style.fontWeight = "400";
      megaMenuItem.style.display = "none";
      megaMenuItem.style.zIndex = "0";
      megaMenuItem.style.pointerEvents = "none";
    }
  });
}

// 2-3
const navigationTier3_3 = navTierWrapper2.querySelector("#NavigationTier3-3");
if (navigationTier3_3) {
  navigationTier3_3.addEventListener("mouseenter", function () {
    var megaMenuItem = navigationTier3_3.querySelector(".mega-menu__item_3");
    var megaMenuLink = navigationTier3_3.querySelector(
      ".navigation__column-title"
    );

    if (megaMenuItem) {
      megaMenuLink.style.fontWeight = "bold";
      megaMenuItem.style.display = "flex";
      // megaMenuItem.style.marginRight = "137px";
      megaMenuItem.style.zIndex = "9999";
      megaMenuItem.style.pointerEvents = "auto";
    }
  });

  navigationTier3_3.addEventListener("mouseleave", function () {
    var megaMenuItem = navigationTier3_3.querySelector(".mega-menu__item_3");
    var megaMenuLink = navigationTier3_3.querySelector(
      ".navigation__column-title"
    );

    if (megaMenuItem) {
      megaMenuLink.style.fontWeight = "400";
      megaMenuItem.style.display = "none";
      megaMenuItem.style.zIndex = "0";
      megaMenuItem.style.pointerEvents = "none";
    }
  });
}

//2-4
const navigationTier3_4 = navTierWrapper2.querySelector("#NavigationTier3-4");
if (navigationTier3_4) {
  navigationTier3_4.addEventListener("mouseenter", function () {
    var megaMenuItem = navigationTier3_4.querySelector(".mega-menu__item_3");
    var megaMenuLink = navigationTier3_4.querySelector(
      ".navigation__column-title"
    );

    if (megaMenuItem) {
      megaMenuLink.style.fontWeight = "bold";
      megaMenuItem.style.display = "flex";
      megaMenuItem.style.marginRight = "94px";
      megaMenuItem.style.zIndex = "9999";
      megaMenuItem.style.pointerEvents = "auto";
    }
  });

  navigationTier3_4.addEventListener("mouseleave", function () {
    var megaMenuItem = navigationTier3_4.querySelector(".mega-menu__item_3");
    var megaMenuLink = navigationTier3_4.querySelector(
      ".navigation__column-title"
    );

    if (megaMenuItem) {
      megaMenuLink.style.fontWeight = "400";
      megaMenuItem.style.display = "none";
      megaMenuItem.style.zIndex = "0";
      megaMenuItem.style.pointerEvents = "none";
    }
  });
}

//2-5
const navigationTier3_5 = navTierWrapper2.querySelector("#NavigationTier3-5");
if (navigationTier3_5) {
  navigationTier3_5.addEventListener("mouseenter", function () {
    var megaMenuItem = navigationTier3_5.querySelector(".mega-menu__item_3");
    var megaMenuLink = navigationTier3_5.querySelector(
      ".navigation__column-title"
    );

    if (megaMenuItem) {
      megaMenuLink.style.fontWeight = "bold";
      megaMenuItem.style.display = "flex";
      megaMenuItem.style.marginRight = "94px";
      megaMenuItem.style.zIndex = "9999";
      megaMenuItem.style.pointerEvents = "auto";
    }
  });

  navigationTier3_5.addEventListener("mouseleave", function () {
    var megaMenuItem = navigationTier3_5.querySelector(".mega-menu__item_3");
    var megaMenuLink = navigationTier3_5.querySelector(
      ".navigation__column-title"
    );

    if (megaMenuItem) {
      megaMenuLink.style.fontWeight = "400";
      megaMenuItem.style.display = "none";
      megaMenuItem.style.zIndex = "0";
      megaMenuItem.style.pointerEvents = "none";
    }
  });
}

//3-1
const navTierWrapper3 = document.getElementById("NavigationTier-Wrapper-2-5");
const navigationTier3_1_3 = navTierWrapper3.querySelector("#NavigationTier3-1");

if (navigationTier3_1_3) {
  navigationTier3_1_3.addEventListener("mouseenter", function () {
    var megaMenuItem = navigationTier3_1_3.querySelector(".mega-menu__item_3");
    var megaMenuLink = navigationTier3_1_3.querySelector(
      ".navigation__column-title"
    );

    if (megaMenuItem) {
      megaMenuLink.style.fontWeight = "bold";
      megaMenuItem.style.display = "flex";
      megaMenuItem.style.zIndex = "9999";
      megaMenuItem.style.pointerEvents = "auto";
    }
  });

  navigationTier3_1_3.addEventListener("mouseleave", function () {
    var megaMenuItem = navigationTier3_1_3.querySelector(".mega-menu__item_3");
    var megaMenuLink = navigationTier3_1_3.querySelector(
      ".navigation__column-title"
    );

    if (megaMenuItem) {
      megaMenuLink.style.fontWeight = "400";
      megaMenuItem.style.display = "none";
      megaMenuItem.style.zIndex = "-1";
      megaMenuItem.style.pointerEvents = "none";
    }
  });
}

//3-2
const navigationTier3_2_3 = navTierWrapper3.querySelector("#NavigationTier3-2");
if (navigationTier3_2_3) {
  navigationTier3_2_3.addEventListener("mouseenter", function () {
    var megaMenuItem = navigationTier3_2_3.querySelector(".mega-menu__item_3");
    var megaMenuLink = navigationTier3_2_3.querySelector(
      ".navigation__column-title"
    );

    if (megaMenuItem) {
      megaMenuLink.style.fontWeight = "bold";
      megaMenuItem.style.display = "flex";
      megaMenuItem.style.zIndex = "9999";
      megaMenuItem.style.pointerEvents = "auto";
    }
  });

  navigationTier3_2_3.addEventListener("mouseleave", function () {
    var megaMenuItem = navigationTier3_2_3.querySelector(".mega-menu__item_3");
    var megaMenuLink = navigationTier3_2_3.querySelector(
      ".navigation__column-title"
    );

    if (megaMenuItem) {
      megaMenuLink.style.fontWeight = "400";
      megaMenuItem.style.display = "none";
      megaMenuItem.style.zIndex = "0";
      megaMenuItem.style.pointerEvents = "none";
    }
  });
}

// 3-3
const navigationTier3_3_3 = navTierWrapper3.querySelector("#NavigationTier3-3");
if (navigationTier3_3_3) {
  navigationTier3_3_3.addEventListener("mouseenter", function () {
    var megaMenuItem = navigationTier3_3_3.querySelector(".mega-menu__item_3");
    var megaMenuLink = navigationTier3_3_3.querySelector(
      ".navigation__column-title"
    );

    if (megaMenuItem) {
      megaMenuLink.style.fontWeight = "bold";
      megaMenuItem.style.display = "flex";
      megaMenuItem.style.zIndex = "9999";
      megaMenuItem.style.pointerEvents = "auto";
    }
  });

  navigationTier3_3_3.addEventListener("mouseleave", function () {
    var megaMenuItem = navigationTier3_3_3.querySelector(".mega-menu__item_3");
    var megaMenuLink = navigationTier3_3_3.querySelector(
      ".navigation__column-title"
    );

    if (megaMenuItem) {
      megaMenuLink.style.fontWeight = "400";
      megaMenuItem.style.display = "none";
      megaMenuItem.style.zIndex = "0";
      megaMenuItem.style.pointerEvents = "none";
    }
  });
}

//3-4
const navigationTier3_4_3 = navTierWrapper3.querySelector("#NavigationTier3-4");
if (navigationTier3_4_3) {
  navigationTier3_4_3.addEventListener("mouseenter", function () {
    var megaMenuItem = navigationTier3_4_3.querySelector(".mega-menu__item_3");
    var megaMenuLink = navigationTier3_4_3.querySelector(
      ".navigation__column-title"
    );

    if (megaMenuItem) {
      megaMenuLink.style.fontWeight = "bold";
      megaMenuItem.style.display = "flex";
      megaMenuItem.style.marginRight = "94px";
      megaMenuItem.style.zIndex = "9999";
      megaMenuItem.style.pointerEvents = "auto";
    }
  });

  navigationTier3_4_3.addEventListener("mouseleave", function () {
    var megaMenuItem = navigationTier3_4_3.querySelector(".mega-menu__item_3");
    var megaMenuLink = navigationTier3_4_3.querySelector(
      ".navigation__column-title"
    );

    if (megaMenuItem) {
      megaMenuLink.style.fontWeight = "400";
      megaMenuItem.style.display = "none";
      megaMenuItem.style.zIndex = "0";
      megaMenuItem.style.pointerEvents = "none";
    }
  });
}
//3-5
const navigationTier3_5_3 = navTierWrapper3.querySelector("#NavigationTier3-5");
if (navigationTier3_5_3) {
  navigationTier3_5_3.addEventListener("mouseenter", function () {
    var megaMenuItem = navigationTier3_5_3.querySelector(".mega-menu__item_3");
    var megaMenuLink = navigationTier3_5_3.querySelector(
      ".navigation__column-title"
    );

    if (megaMenuItem) {
      megaMenuLink.style.fontWeight = "bold";
      megaMenuItem.style.display = "flex";
      megaMenuItem.style.marginRight = "94px";
      megaMenuItem.style.zIndex = "9999";
      megaMenuItem.style.pointerEvents = "auto";
    }
  });

  navigationTier3_5_3.addEventListener("mouseleave", function () {
    var megaMenuItem = navigationTier3_5_3.querySelector(".mega-menu__item_3");
    var megaMenuLink = navigationTier3_5_3.querySelector(
      ".navigation__column-title"
    );

    if (megaMenuItem) {
      megaMenuLink.style.fontWeight = "400";
      megaMenuItem.style.display = "none";
      megaMenuItem.style.zIndex = "0";
      megaMenuItem.style.pointerEvents = "none";
    }
  });
}
//4-1
const navTierWrapper4 = document.getElementById("NavigationTier-Wrapper-2-6");
const navigationTier3_1_4 = navTierWrapper4.querySelector("#NavigationTier3-1");

if (navigationTier3_1_4) {
  navigationTier3_1_4.addEventListener("mouseenter", function () {
    var megaMenuItem = navigationTier3_1_4.querySelector(".mega-menu__item_3");
    var megaMenuLink = navigationTier3_1_4.querySelector(
      ".navigation__column-title"
    );

    if (megaMenuItem) {
      megaMenuLink.style.fontWeight = "bold";
      megaMenuItem.style.display = "flex";
      megaMenuItem.style.zIndex = "9999";
      megaMenuItem.style.pointerEvents = "auto";
    }
  });

  navigationTier3_1_4.addEventListener("mouseleave", function () {
    var megaMenuItem = navigationTier3_1_4.querySelector(".mega-menu__item_3");
    var megaMenuLink = navigationTier3_1_4.querySelector(
      ".navigation__column-title"
    );

    if (megaMenuItem) {
      megaMenuLink.style.fontWeight = "400";
      megaMenuItem.style.display = "none";
      megaMenuItem.style.zIndex = "-1";
      megaMenuItem.style.pointerEvents = "none";
    }
  });
}

//4-2
const navigationTier3_2_4 = navTierWrapper4.querySelector("#NavigationTier3-2");
if (navigationTier3_2_4) {
  navigationTier3_2_4.addEventListener("mouseenter", function () {
    var megaMenuItem = navigationTier3_2_4.querySelector(".mega-menu__item_3");
    var megaMenuLink = navigationTier3_2_4.querySelector(
      ".navigation__column-title"
    );

    if (megaMenuItem) {
      megaMenuLink.style.fontWeight = "bold";
      megaMenuItem.style.display = "flex";
      megaMenuItem.style.zIndex = "9999";
      megaMenuItem.style.pointerEvents = "auto";
    }
  });

  navigationTier3_2_4.addEventListener("mouseleave", function () {
    var megaMenuItem = navigationTier3_2_4.querySelector(".mega-menu__item_3");
    var megaMenuLink = navigationTier3_2_4.querySelector(
      ".navigation__column-title"
    );

    if (megaMenuItem) {
      megaMenuLink.style.fontWeight = "400";
      megaMenuItem.style.display = "none";
      megaMenuItem.style.zIndex = "0";
      megaMenuItem.style.pointerEvents = "none";
    }
  });
}

// 4-3
const navigationTier3_3_4 = navTierWrapper4.querySelector("#NavigationTier3-3");
if (navigationTier3_3_4) {
  navigationTier3_3_4.addEventListener("mouseenter", function () {
    var megaMenuItem = navigationTier3_3_4.querySelector(".mega-menu__item_3");
    var megaMenuLink = navigationTier3_3_4.querySelector(
      ".navigation__column-title"
    );

    if (megaMenuItem) {
      megaMenuLink.style.fontWeight = "bold";
      megaMenuItem.style.display = "flex";
      megaMenuItem.style.zIndex = "9999";
      megaMenuItem.style.pointerEvents = "auto";
    }
  });

  navigationTier3_3_4.addEventListener("mouseleave", function () {
    var megaMenuItem = navigationTier3_3_4.querySelector(".mega-menu__item_3");
    var megaMenuLink = navigationTier3_3_4.querySelector(
      ".navigation__column-title"
    );

    if (megaMenuItem) {
      megaMenuLink.style.fontWeight = "400";
      megaMenuItem.style.display = "none";
      megaMenuItem.style.zIndex = "0";
      megaMenuItem.style.pointerEvents = "none";
    }
  });
}

//4-4
const navigationTier3_4_4 = navTierWrapper4.querySelector("#NavigationTier3-4");
if (navigationTier3_4_4) {
  navigationTier3_4_4.addEventListener("mouseenter", function () {
    var megaMenuItem = navigationTier3_4_4.querySelector(".mega-menu__item_3");
    var megaMenuLink = navigationTier3_4_4.querySelector(
      ".navigation__column-title"
    );

    if (megaMenuItem) {
      megaMenuLink.style.fontWeight = "bold";
      megaMenuItem.style.display = "flex";
      megaMenuItem.style.marginRight = "94px";
      megaMenuItem.style.zIndex = "9999";
      megaMenuItem.style.pointerEvents = "auto";
    }
  });

  navigationTier3_4_4.addEventListener("mouseleave", function () {
    var megaMenuItem = navigationTier3_4_4.querySelector(".mega-menu__item_3");
    var megaMenuLink = navigationTier3_4_4.querySelector(
      ".navigation__column-title"
    );

    if (megaMenuItem) {
      megaMenuLink.style.fontWeight = "400";
      megaMenuItem.style.display = "none";
      megaMenuItem.style.zIndex = "0";
      megaMenuItem.style.pointerEvents = "none";
    }
  });
}

//4-5
const navigationTier3_5_4 = navTierWrapper4.querySelector("#NavigationTier3-5");
if (navigationTier3_5_4) {
  navigationTier3_5_4.addEventListener("mouseenter", function () {
    var megaMenuItem = navigationTier3_5_4.querySelector(".mega-menu__item_3");
    var megaMenuLink = navigationTier3_5_4.querySelector(
      ".navigation__column-title"
    );

    if (megaMenuItem) {
      megaMenuLink.style.fontWeight = "bold";
      megaMenuItem.style.display = "flex";
      megaMenuItem.style.marginRight = "94px";
      megaMenuItem.style.zIndex = "9999";
      megaMenuItem.style.pointerEvents = "auto";
    }
  });

  navigationTier3_5_4.addEventListener("mouseleave", function () {
    var megaMenuItem = navigationTier3_5_4.querySelector(".mega-menu__item_3");
    var megaMenuLink = navigationTier3_5_4.querySelector(
      ".navigation__column-title"
    );

    if (megaMenuItem) {
      megaMenuLink.style.fontWeight = "400";
      megaMenuItem.style.display = "none";
      megaMenuItem.style.zIndex = "0";
      megaMenuItem.style.pointerEvents = "none";
    }
  });
}

//5-1
const navTierWrapper5 = document.getElementById("NavigationTier-Wrapper-2-7");
const navigationTier3_1_5 = navTierWrapper5.querySelector("#NavigationTier3-1");

if (navigationTier3_1_5) {
  navigationTier3_1_5.addEventListener("mouseenter", function () {
    var megaMenuItem = navigationTier3_1_5.querySelector(".mega-menu__item_3");
    var megaMenuLink = navigationTier3_1_5.querySelector(
      ".navigation__column-title"
    );

    if (megaMenuItem) {
      megaMenuLink.style.fontWeight = "bold";
      megaMenuItem.style.display = "flex";
      megaMenuItem.style.zIndex = "9999";
      megaMenuItem.style.pointerEvents = "auto";
    }
  });

  navigationTier3_1_5.addEventListener("mouseleave", function () {
    var megaMenuItem = navigationTier3_1_5.querySelector(".mega-menu__item_3");
    var megaMenuLink = navigationTier3_1_5.querySelector(
      ".navigation__column-title"
    );

    if (megaMenuItem) {
      megaMenuLink.style.fontWeight = "400";
      megaMenuItem.style.display = "none";
      megaMenuItem.style.zIndex = "-1";
      megaMenuItem.style.pointerEvents = "none";
    }
  });
}

//5-2
const navigationTier3_2_5 = navTierWrapper5.querySelector("#NavigationTier3-2");
if (navigationTier3_2_5) {
  navigationTier3_2_5.addEventListener("mouseenter", function () {
    var megaMenuItem = navigationTier3_2_5.querySelector(".mega-menu__item_3");
    var megaMenuLink = navigationTier3_2_5.querySelector(
      ".navigation__column-title"
    );

    if (megaMenuItem) {
      megaMenuLink.style.fontWeight = "bold";
      megaMenuItem.style.display = "flex";
      megaMenuItem.style.zIndex = "9999";
      megaMenuItem.style.pointerEvents = "auto";
    }
  });

  navigationTier3_2_5.addEventListener("mouseleave", function () {
    var megaMenuItem = navigationTier3_2_5.querySelector(".mega-menu__item_3");
    var megaMenuLink = navigationTier3_2_5.querySelector(
      ".navigation__column-title"
    );

    if (megaMenuItem) {
      megaMenuLink.style.fontWeight = "400";
      megaMenuItem.style.display = "none";
      megaMenuItem.style.zIndex = "0";
      megaMenuItem.style.pointerEvents = "none";
    }
  });
}

// 5-3
const navigationTier3_3_5 = navTierWrapper5.querySelector("#NavigationTier3-3");
if (navigationTier3_3_5) {
  navigationTier3_3_5.addEventListener("mouseenter", function () {
    var megaMenuItem = navigationTier3_3_5.querySelector(".mega-menu__item_3");
    var megaMenuLink = navigationTier3_3_5.querySelector(
      ".navigation__column-title"
    );

    if (megaMenuItem) {
      megaMenuLink.style.fontWeight = "bold";
      megaMenuItem.style.display = "flex";
      megaMenuItem.style.zIndex = "9999";
      megaMenuItem.style.pointerEvents = "auto";
    }
  });

  navigationTier3_3_5.addEventListener("mouseleave", function () {
    var megaMenuItem = navigationTier3_3_5.querySelector(".mega-menu__item_3");
    var megaMenuLink = navigationTier3_3_5.querySelector(
      ".navigation__column-title"
    );

    if (megaMenuItem) {
      megaMenuLink.style.fontWeight = "400";
      megaMenuItem.style.display = "none";
      megaMenuItem.style.zIndex = "0";
      megaMenuItem.style.pointerEvents = "none";
    }
  });
}

//5-4
const navigationTier3_4_5 = navTierWrapper5.querySelector("#NavigationTier3-4");
if (navigationTier3_4_5) {
  navigationTier3_4_5.addEventListener("mouseenter", function () {
    var megaMenuItem = navigationTier3_4_5.querySelector(".mega-menu__item_3");
    var megaMenuLink = navigationTier3_4_5.querySelector(
      ".navigation__column-title"
    );

    if (megaMenuItem) {
      megaMenuLink.style.fontWeight = "bold";
      megaMenuItem.style.display = "flex";
      megaMenuItem.style.marginRight = "94px";
      megaMenuItem.style.zIndex = "9999";
      megaMenuItem.style.pointerEvents = "auto";
    }
  });

  navigationTier3_4_5.addEventListener("mouseleave", function () {
    var megaMenuItem = navigationTier3_4_5.querySelector(".mega-menu__item_3");
    var megaMenuLink = navigationTier3_4_5.querySelector(
      ".navigation__column-title"
    );

    if (megaMenuItem) {
      megaMenuLink.style.fontWeight = "400";
      megaMenuItem.style.display = "none";
      megaMenuItem.style.zIndex = "0";
      megaMenuItem.style.pointerEvents = "none";
    }
  });
}

//5-5
const navigationTier3_5_5 = navTierWrapper5.querySelector("#NavigationTier3-5");
if (navigationTier3_5_5) {
  navigationTier3_5_5.addEventListener("mouseenter", function () {
    var megaMenuItem = navigationTier3_5_5.querySelector(".mega-menu__item_3");
    var megaMenuLink = navigationTier3_5_5.querySelector(
      ".navigation__column-title"
    );

    if (megaMenuItem) {
      megaMenuLink.style.fontWeight = "bold";
      megaMenuItem.style.display = "flex";
      megaMenuItem.style.marginRight = "94px";
      megaMenuItem.style.zIndex = "9999";
      megaMenuItem.style.pointerEvents = "auto";
    }
  });

  navigationTier3_5_5.addEventListener("mouseleave", function () {
    var megaMenuItem = navigationTier3_5_5.querySelector(".mega-menu__item_3");
    var megaMenuLink = navigationTier3_5_5.querySelector(
      ".navigation__column-title"
    );

    if (megaMenuItem) {
      megaMenuLink.style.fontWeight = "400";
      megaMenuItem.style.display = "none";
      megaMenuItem.style.zIndex = "0";
      megaMenuItem.style.pointerEvents = "none";
    }
  });
}


  document.addEventListener("DOMContentLoaded", function () {
    const guide = document.querySelector('.steps-guide');
    const items = Array.from(guide.querySelectorAll('.step-item'));
    const btnLeft = document.querySelector('.scroll-arrow--left');
    const btnRight = document.querySelector('.scroll-arrow--right');

    function scrollToNext(offset) {
      const scrollLeft = guide.scrollLeft;
      const containerWidth = guide.offsetWidth;

      // Найдём текущий активный элемент по прокрутке
      const currentIndex = items.findIndex(item => {
        return item.offsetLeft >= scrollLeft - 1 && item.offsetLeft < scrollLeft + containerWidth;
      });

      const newIndex = Math.min(Math.max(currentIndex + offset, 0), items.length - 1);
      guide.scrollTo({
        left: items[newIndex].offsetLeft,
        behavior: 'smooth'
      });
    }

    btnLeft.addEventListener('click', () => scrollToNext(-1));
    btnRight.addEventListener('click', () => scrollToNext(1));
  });
